import logo from '@/components/logo.webp'
import { twMerge } from 'tailwind-merge'

/**
 * The Lingo mark for the v2 flow's mascot moments and question prompts.
 *
 * The source asset centres the mark inside a square canvas with roughly 15%
 * of transparent padding either side, so rendering it at the box size leaves
 * the mark noticeably smaller than the space it reserves. Scaling the image
 * past the box instead makes the box match the visible mark, which is what
 * callers are actually sizing against. The mark's own 1.46:1 aspect then puts
 * its height at about two thirds of the box.
 */
export default function DuoMascot({ className }: { className?: string }) {
  return (
    <span
      className={twMerge(
        'animate-float grid h-24 w-24 place-items-center',
        className,
      )}
    >
      <img alt="" className="w-[145%] max-w-none" src={logo} />
    </span>
  )
}
